import { Model } from '../../_kernel/architecture'
import { z } from 'zod'

const BoardGroupValidation = z.object({
  name: z.string({ required_error: '[BoardGroup] name is required' }),
  code: z.string({ required_error: '[BoardGroup] code is required' }),
})

export class BoardGroup extends Model {
  static create({ name, code }: z.infer<typeof BoardGroupValidation>) {
    BoardGroupValidation.parse({ name, code })
    return new BoardGroup(name, code)
  }

  static fromJSON({ name, code }: z.infer<typeof BoardGroupValidation>) {
    return new BoardGroup(name, code)
  }

  constructor(
    private readonly _name: string,
    private readonly _code: string
  ) {
    super()
  }

  name() {
    return this._name
  }

  code() {
    return this._code
  }

  toJSON() {
    return {
      name: this.name(),
      code: this.code(),
    }
  }
}
